'use client';

import { Button } from '@mui/material';

import { AbgTypography, mergeSx, useTranslation } from '@abg/kit-base';

import { useAnalyticsLoginFunnel } from '../../../shared/analytics/hooks';

import { selectMfaFormFooterStyling as styling } from './SelectMfaFormFooter.styling';
import { SelectMfaFormFooterProps } from './types';

export const SelectMfaFormFooter = ({
  model,
  selectedMethod,
  onConfirm,
}: SelectMfaFormFooterProps) => {
  const t = useTranslation(model.i18n);
  const recordAnalyticsLoginFunnel = useAnalyticsLoginFunnel();

  return (
    <>
      <Button
        data-testid="mfa-dialog-confirm-button"
        onClick={() => {
          recordAnalyticsLoginFunnel({
            method: 'Wizard ID',
            login_state: 'login',
            step_number: 2,
            step_description: 'Two Factor Authentication',
          });
          onConfirm(selectedMethod!);
        }}
        variant="outlined"
        sx={mergeSx(styling.confirmBtn)}
        disabled={!selectedMethod}
      >
        <AbgTypography component="span">
          {t('mfa.modal.cta.getCode.title')}
        </AbgTypography>
      </Button>
    </>
  );
};
